export const breakAllRendererFields = [
  "Attorney Email",
  "Attorney Name",
  "Sub-Status"
];

export const noWrapRendererFields = [

];